import React, { useEffect, useState } from 'react';
import { Collapse, Button } from 'reactstrap';

type NumberSelectorProps = {
  initial: number;
  min: number;
  max: number;
  handleSelectionChanged: (selectedNumber: number) => void;
  singleLabel?: string;
  multipleLabel?: string;
  approveLabel?: string;
  collapseAbsolute?: boolean;
};

const NumberSelector = (props: NumberSelectorProps) => {
  const {
    initial,
    min,
    max,
    handleSelectionChanged,
    singleLabel,
    multipleLabel,
    approveLabel,
    collapseAbsolute
  } = props;

  const [selectedNumber, setSelectedNumber] = useState<number>(initial);
  const [prevValue, setPrevValue] = useState<number>(initial);

  useEffect(() => {
    setSelectedNumber(initial);
    setPrevValue(initial);
  }, [initial]);

  const minus = () => {
    if (selectedNumber > min) {
      setSelectedNumber(selectedNumber - 1);
    }
  };

  const plus = () => {
    if (selectedNumber < max) {
      setSelectedNumber(selectedNumber + 1);
    }
  };

  const changeNumber = () => {
    setPrevValue(selectedNumber);
    handleSelectionChanged(selectedNumber);
  };

  return (
    <>
      <div className="iso__number-selector">
        <Button
          color="primary"
          onClick={minus}
          disabled={selectedNumber === min}
          data-testid="minus-btn"
        >
          -
        </Button>
        <div className="label">
          {!singleLabel && !multipleLabel && <p>{selectedNumber} selected</p>}
          {singleLabel && multipleLabel && (
            <p>
              {selectedNumber} {selectedNumber === 1 ? singleLabel : multipleLabel}
            </p>
          )}
        </div>
        <Button
          color="primary"
          onClick={plus}
          disabled={selectedNumber === max}
          data-testid="plus-btn"
        >
          +
        </Button>
      </div>
      <Collapse
        className={`iso__number-selector-collapse mt-2 p-4 ${
          collapseAbsolute ? 'collapse-absolute' : ''
        }`}
        isOpen={selectedNumber !== prevValue}
        data-testid="collapse"
      >
        <Button color="primary" onClick={changeNumber} data-testid="approve-btn">
          {approveLabel ? approveLabel : 'Approve'}
        </Button>
      </Collapse>
    </>
  );
};

export default NumberSelector;
